import React, { PropsWithChildren } from 'react';
import { BpIntlProviderImpl, BpIntlProviderImplProps } from './BpIntlProviderImpl';
import { BpIntlProviderContextProvider } from './BpIntlProviderContextProvider';

export interface BpIntlProviderProps<SUPPORTED_LANG extends string> extends BpIntlProviderImplProps {
  /**
   * Default language code go first
   */
  supportedLanguages: SUPPORTED_LANG[];
}

export function BpIntlProvider<SUPPORTED_LANG extends string>({
  children,
  messages,
  supportedLanguages,
  getMessages
}: PropsWithChildren<BpIntlProviderProps<SUPPORTED_LANG>>) {
  const messagesLoaded = !!Object.keys(messages).length;

  if (!messagesLoaded) {
    return null;
  }

  return (
    <BpIntlProviderContextProvider supportedLanguages={supportedLanguages}>
      <BpIntlProviderImpl messages={messages} getMessages={getMessages}>
        {children}
      </BpIntlProviderImpl>
    </BpIntlProviderContextProvider>
  );
}
